<template>
  <div id="score-report">
    <report-page-header :title="$t('score_report.main_page_title')" />
    <student-tab v-if="shouldShowSingleStudentReport"></student-tab>
    <tabs :tabs="tabs" v-else></tabs>
  </div>
</template>

<script>
import { ReportPageHeader, Tabs } from "../Components";
import OverviewTab from "./Overview";
import StudentTab from "./Student";
import { mapGetters } from "vuex";
import Role from "@/constants/Role";
import { hasValidRole } from "@/helpers/role-helper";

export default {
  components: { Tabs, ReportPageHeader, StudentTab },
  data() {
    const tabs = [
      {
        name: "overview",
        label: "Overview",
        component: OverviewTab
      },
      {
        name: "student",
        label: "Per student",
        component: StudentTab
      }
    ];
    return {
      tabs
    };
  },
  computed: {
    ...mapGetters("user", {
      userRole: "role"
    }),
    shouldShowSingleStudentReport() {
      return hasValidRole(this.userRole, [Role.Student, Role.Family]);
    }
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
@import "~vue-material/dist/theme/engine";

.tab-button {
  @apply py-2 px-4;
  @apply text-gray-500 font-medium;
  @apply cursor-pointer;
  @apply outline-none;

  font-size: 1rem;

  &.active {
    border-top: 2px solid md-get-palette-color(purple, 500);
  }
}
</style>
